export const DASHBOARD_COLUMNS_COUNT = 3;

/**
 * Whether a tab declares its cards layout: at least one card outside column 0.
 * A tab without declared columns gets all its cards in column 0 (legacy default) and keeps the masonry grid.
 * @param {Array<Pick<ApiDashboardFieldset, 'column'>> | undefined} fieldsets - Cards of the tab
 * @returns {boolean} True when the cards must be placed in their columns
 */
export const hasDeclaredColumns = (fieldsets) => (
  (fieldsets ?? []).some((fieldset) => (fieldset.column ?? 0) > 0)
);

/**
 * Group the cards of a tab by column, each column sorted by position.
 * Positions may have gaps (hidden cards keep their place): they are sorted, never counted.
 * A column outside 0-2 is clamped to the nearest column (defensive: the API sends 0-2).
 * @template {Pick<ApiDashboardFieldset, 'column' | 'position'>} T
 * @param {Array<T> | undefined} fieldsets - Cards of the tab
 * @returns {Array<Array<T>>} One array per column, always 3 columns
 */
export const groupFieldsetsByColumn = (fieldsets) => {
  /** @type {Array<Array<T>>} */
  const columns = Array.from({ length: DASHBOARD_COLUMNS_COUNT }, () => []);
  (fieldsets ?? []).forEach((fieldset) => {
    const column = Math.min(Math.max(fieldset.column ?? 0, 0), DASHBOARD_COLUMNS_COUNT - 1);
    columns[column].push(fieldset);
  });
  return columns.map((column) => [...column].sort((a, b) => (a.position ?? 0) - (b.position ?? 0)));
};
